module.exports = __webpack_public_path__ + "img/mv04.53a545b3.jpg";